import deepFreeze from 'deep-freeze';
import serviceFactory from '@/services/serviceFactory';

export const ENDPOINTS = deepFreeze({
    SPACE_GROUPS: {
        URI: () => '/api/v1/spaces/{{spaceId}}/producer-product-groups',
        methods: ['get', 'post'],
    },
    GROUPS: {
        URI: () => '/api/v1/producer-product-groups/{{id?}}',
        methods: ['get', 'patch', 'delete'],
        cacheToClear: ['/api/v1/spaces/\\d+/producer-product-groups'],
    },
    GROUP_PRODUCTS: {
        URI: () => '/api/v1/producer-product-groups/{{groupId}}/products/{{id?}}',
        methods: ['get', 'post', 'delete'],
        cacheToClear: ['/api/v1/spaces/\\d+/producer-product-groups', '/api/v1/producer-product-groups/{{groupId}}', '/api/v1/producer-products/{{id}}/producer-product-groups'],
    },
    GROUP_CATEGORIES: {
        URI: () => '/api/v1/producer-product-groups/{{groupId}}/categories/{{id?}}',
        methods: ['get', 'post', 'delete'],
        cacheToClear: ['/api/v1/spaces/\\d+/producer-product-groups', '/api/v1/producer-product-groups/{{groupId}}', '/api/v1/producer-product-categories/{{id}}/producer-product-groups'],
    },
});

export default {
    ...serviceFactory.build(ENDPOINTS),
};
